angular.module('SpidApp')

/*
- nom agence
- regate agence
- le vendeur
- date de vente
- total de la vente
- vente validé ou non
- nombre de vignettes unvalidés
- nombre de vignettes imprimées correctement
- currency_rate
- nombre de produits distinct
*/


.controller('OperationsController', 
		['CsvConverter', '$filter', '$scope', 'TransactionService', 'AgencyService', 'SaleService',
function (CsvConverter,   $filter,   $scope,   TransactionService,   AgencyService,   SaleService) {
	var date    =  moment();

	$scope.currentDate = date.format('LL');
	
	$scope.currentPage 			= 1;
	$scope.maxPaginationSize 	= 10;
	$scope.itemsPerPage 		= 15;
        
	AgencyService.all().then(function (agencies) {
        $scope.agencies = agencies
        var groupedAgencies = _.indexBy(agencies, function (agency) {
            return agency.id 
        })
        $scope.groupedAgencies = groupedAgencies;

        TransactionService.all().then(function (transactions) {
            $scope.transactionsRef = $scope.transactions = transactions.map(function (transaction) {
                SaleService.findByTransactionId(transaction.agency_id, transaction.id).then(function (sales) {
                    transaction.nbImpressionCancel = _.chain(sales).filter(function (sale) {
                            return (sale.type === "Refund");
                        }).reduce(function (memo, st) {
                            return memo + st.quantity;
                        }, 0).value();

                    transaction.nbImpressionOk = _.chain(sales).filter(function (sale) {
                            return (sale.type === "Stamp");
                        }).reduce(function (memo2, st2) {
                            return memo2 + st2.quantity;
                        }, 0).value() - transaction.nbImpressionCancel;

                    transaction.nbDistinctSales = sales.length;
                })

                var targetAgency = groupedAgencies[transaction.agency_id]
                if (targetAgency) {
                    transaction.agencyName = targetAgency.name
                    transaction.agencyCodeRegate = targetAgency.code_regate

                    if (targetAgency.currency && targetAgency.currency.symbol) {
                        transaction.currencySymbol = targetAgency.currency.symbol
                        transaction.currencyRate = targetAgency.currency.rate
                    }
                }

                transaction.updatedAtLocaleString = new Date(transaction.updatedAt).toLocaleString()
                return transaction
            })
            
            $scope.pageChanged();
        })
    })

    $scope.agencyNameFilter = ''
    $scope.periodFilter = ''
    $scope.usernameFilter = ''



    $scope.exportToCsv = function () {
        var transactions = $scope.transactions

        var filteredTransactions = $filter('filter')(transactions, {
            username: $scope.usernameFilter,
            agencyName: $scope.agencyNameFilter,
            updatedAtLocaleString: $scope.periodFilter
        })

        var csv = CsvConverter.arrayToCsv(filteredTransactions, ['agencyName', 'agencyCodeRegate', 'username', 'updatedAt', 'bill', 'nbImpressionOk', 'nbImpressionCancel', 'currencyRate', 'nbDistinctSales'], {
            hasHeaders: true
        })
        var element = document.createElement('a')
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv))
        element.setAttribute('download', 'export.csv')
        document.body.appendChild(element);
        element.click();
    }
	
	$scope.pageChanged = function() {
	    if(!$scope.transactions){
	        return;
        }
    	$scope.totalItems = $scope.transactions.length;
    	var deb = ($scope.currentPage - 1) * $scope.itemsPerPage;
    	var fin = deb + $scope.itemsPerPage;
    	
    	$scope.pagerTransaction = $scope.transactions.slice(deb, fin);
    };

	var updateTransactionData = function(){
        if(!$scope.search){
            return;
        }

        $scope.transactionsTmp = $scope.transactionsRef;

        if(!!$scope.search.agencyNameFilter){
            $scope.transactionsTmp = _.filter($scope.transactionsTmp,function(transaction){
                if(transaction.agencyName.toUpperCase().indexOf($scope.search.agencyNameFilter.toUpperCase()) != -1){
                    return transaction;
                }
            })
        }
        if(!!$scope.search.periodFilter){
            $scope.transactionsTmp = _.filter($scope.transactionsTmp,function(transaction){
                if(transaction.updatedAtLocaleString.toUpperCase().indexOf($scope.search.periodFilter.toUpperCase()) != -1){
                    return transaction;
                }
            })
        }
        if(!!$scope.search.usernameFilter){
            $scope.transactionsTmp = _.filter($scope.transactionsTmp,function(transaction){
                if(transaction.username.toUpperCase().indexOf($scope.search.usernameFilter.toUpperCase()) != -1){
                    return transaction;
                }
            })
        }

        $scope.transactions = $scope.transactionsTmp;

        $scope.currentPage = 1;
        $scope.pageChanged();
    }

    $scope.$watch('search.agencyNameFilter', function() {
        updateTransactionData();
    });
    $scope.$watch('search.periodFilter', function() {
        updateTransactionData();
    });
    $scope.$watch('search.usernameFilter', function() {
        updateTransactionData();
    });
}])